import { render, staticRenderFns } from "./icon2.vue?vue&type=template&id=b836e54c&scoped=true&"
import script from "./icon2.vue?vue&type=script&lang=js&"
export * from "./icon2.vue?vue&type=script&lang=js&"
import style0 from "./icon2.vue?vue&type=style&index=0&id=b836e54c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b836e54c",
  null
  
)

export default component.exports